module.exports = __webpack_public_path__ + "591887d2f375b8ca4301e8b282332663.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/perks/houses/owl-dobe-desert-casa.png
// module id = 2849
// module chunks = 0